import { Fragment, ReactElement, ReactNode, useContext } from 'react';
import parse from 'html-react-parser';
import cn from 'classnames';
import styles from './UnorderedList.module.scss';
import { AppContext } from '../../context/AppContext';
import { getDataTest } from '../../utils/dataTests';

export interface UnorderedListProps {
    items: Array<string | undefined>;
    className?: string;
    slots?: Record<string, ReactNode>; // token -> co se na jeho místo vykreslí
}

export const UnorderedList = ({ items, className, slots, ...props }: UnorderedListProps): ReactElement | null => {
    const ctx = useContext(AppContext);
    const replacements = ctx.popupContentVariables;

    if (items.length === 0) {
        return null;
    }

    // @TODO: refactor it
    if (replacements !== null && replacements.duration && replacements.age) {
        for (let i = 0; i < items.length; i++) {
            if (items[i]) {
                items[i] = items?.[i]
                    ?.replace('{duration}', replacements.duration.toString())
                    .replace('{age}', replacements.age.toString());
            }
        }
    }

    // ### Rozdělí text podle tokenů ze `slots` a na jejich místa vloží React node
    const renderContent = (item: string): ReactNode => {
        const tokens = slots && Object.keys(slots);
        if (!tokens || tokens.length === 0) {
            return parse(item);
        }
        const escaped = tokens.map((t) => t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
        const regex = new RegExp(`(${escaped.join('|')})`, 'g');

        return item
            .split(regex)
            .map((part, idx) => <Fragment key={idx}>{slots[part] !== undefined ? slots[part] : parse(part)}</Fragment>);
    };

    return (
        <ol className={cn(styles.wrapper, className)} {...props}>
            {items.map(
                (item, i) =>
                    item && (
                        <li key={i} className={styles.item} data-test={getDataTest(props, `Item[${i}]`)}>
                            <span>{renderContent(item)}</span>
                        </li>
                    )
            )}
        </ol>
    );
};
